import { Box, Typography } from '@mui/material'
import { FunctionComponent } from 'react'
import { FormTextInputDisplay } from '../../form-field-components/new-and-edit/form-text-input'
import { SrsMetricsFigures } from './srs-metrics-figures'
import { ISrsFigures, ISrsNarrativeField } from '../../../../shared/services/srs-report/srs-report.model'

/**
 * The Metrics and targets pillar. The figures are read-only: they come from the same aggregator as
 * the GHG and SECR reports, so they reconcile with those documents and are reviewed, not typed. The
 * one editable disclosure is the targets narrative, seeded from the recorded reduction targets.
 */
export const SrsStepMetrics: FunctionComponent<{
  sectionLabel: string
  figures: ISrsFigures
  targetsField: ISrsNarrativeField | null
  values: Record<string, string>
  onChange: (field: string, value: string) => void
}> = ({ sectionLabel, figures, targetsField, values, onChange }) => {
  return (
    <>
      <Typography variant='h6' sx={{ mb: 1 }}>{sectionLabel}</Typography>
      <Typography variant='body2' sx={{ color: 'text.secondary', mb: 3 }}>
        These figures are calculated the same way as your greenhouse gas and SECR reports for the same
        period, so they will match those reports exactly. Review them here; they are frozen when the
        report is generated.
      </Typography>

      <SrsMetricsFigures figures={figures} />

      {targetsField && (
        <Box sx={{ mb: 3 }}>
          <FormTextInputDisplay
            isEditPage={false}
            disabled={false}
            title={targetsField.heading}
            name={targetsField.field}
            value={values[targetsField.field] || ''}
            onChange={(event: any) => onChange(targetsField.field, event.target.value)}
            multiline
            rows={5}
            forceOutlined
            regularFieldLabel
            isTopRow
            isBottomRow
            helperText={targetsField.guidance}
          />
          <Typography variant='caption' sx={{ display: 'block', color: 'text.secondary', mt: 0.5 }}>
            {targetsField.reference}
          </Typography>
        </Box>
      )}
    </>
  )
}
